module.exports = __webpack_public_path__ + "static/media/Alice-Bloomfield.acde42ac.jpg";